<template>
  <div class="listContainer" @keyup.enter="onSearch">
    <!-- 面包屑 -->
    <a-breadcrumb class="breadcrumb">
      <span slot="separator">></span>
      <a-breadcrumb-item>运营数据</a-breadcrumb-item>
      <a-breadcrumb-item>
        <a>项目战报</a>
      </a-breadcrumb-item>
    </a-breadcrumb>
    <!-- 面包屑 end   -->
    <!-- 增加&搜索 -->
    <section>
      <section class="searchBox">
        <span>
          <label>项目：</label>
          <a-select
            style="min-width:160px"
            v-model="project_id"
            showSearch
            :filterOption="filterOption"
          >
            <a-select-option
              v-for="element in proList"
              :key="element.id"
              :value="element.id"
              >{{ element.project_name }}</a-select-option
            >
          </a-select>
        </span>
        <span>
          <label>结算月：</label>
          <a-month-picker @change="selectedDate" v-model="dateDefault" />
        </span>
        <!-- <span>
          <label>字符串：</label>
          <a>
            <a-input v-model="query_field" placeholder="请输入姓名 | 手机号码" />
          </a>
        </span>-->
        <span>
          <a-button style="margin-right:10px" @click="onDownload">
            <a-icon type="vertical-align-bottom" />下载
          </a-button>
          <a-button style="margin-right:10px" @click="onReset">重置</a-button>
          <a-button type="primary" icon="search" @click="onSearch"
            >搜索</a-button
          >
        </span>
      </section>
      <!-- 增加&搜索 end-->
      <section class="tableStyles">
        <table>
          <thead>
            <tr>
              <th v-for="item in thList" :key="item">{{ item }}</th>
            </tr>
          </thead>
          <tbody>
            <tr v-show="data == ''">
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td>暂无</td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
            </tr>
            <tr v-show="data.length > 0" v-for="(item, i) in data" :key="i">
              <td>{{ item.project_name }}</td>
              <td>{{ item.guard_count }}</td>
              <td>{{ item.total_work_count }}</td>
              <td>{{ item.had_advance_total }}</td>
              <td>{{ item.service_amount_total }}</td>
              <td>{{ item.can_amount_total }}</td>
              <td>{{ item.proportion + "%" }}</td>
              <td>{{ item.total_checked_guard }}</td>
              <td>{{ item.total_checked_three }}</td>
              <td>{{ item.profit }}</td>
              <td><a @click="setProProportion(item)">设置比例</a></td>
            </tr>
          </tbody>
        </table>
      </section>
      <div class="paginationStyle" :loading="loading">
        <a-pagination
          showQuickJumper
          :defaultCurrent="page"
          :total="pagination.total"
          @change="onChange"
          :current="page"
        />
        <span>{{ "共：" + pagination.total + "条" }}</span>
      </div>
    </section>

    <!-- 设置比例 -->
    <aside class="dialogsBox" v-show="showIsProportion">
      <div>
        <h3>设置比例</h3>
        <a class="close" @click="showIsProportion = false"
          ><a-icon style="font-size: 32px; color: #999" type="close-circle"
        /></a>
        <ul v-if="proprotionVal != ''">
          <li>
            <label>项目：</label>
            <p>{{ proprotionVal.project_name }}</p>
          </li>
          <li>
            <label><i>*</i>预支比例：</label>
            <a-input-number :min="0" v-model="proportion" />
            <span>&nbsp;%</span>
          </li>
        </ul>
        <div>
          <a-button type="primary" @click="submitProprotion"> 提交 </a-button>
        </div>
      </div>
    </aside>
    <!-- 设置比例 end -->
  </div>
</template>
<script>
import axios from "axios";
import { mapState } from "vuex";

export default {
  data() {
    return {
      data: {},
      loading: false,
      page: 1,
      pagination: {},
      hideInAddShow: false,
      query_field: "",
      totalPage: Number,
      thList: [
        "项目名称",
        "员工数量",
        "工单数量",
        "已预支金额",
        "手续费",
        "可预支金额",
        "预支比例",
        "员工结算",
        "甲方结算",
        "利润",
        "操作"
      ],
      start_date: "",
      end_date: "",
      project_id: "",
      proList: [],
      dateDefault: null,
      showIsProportion: false,
      proprotionVal: {},
      proportion: ""
    };
  },
  provide() {
    return {
      reload: this.reload
    };
  },
  mounted() {
    this.getData(); //获取列表
    this.getPro(); //项目
  },
  methods: {
    submitProprotion() {
      this.showIsProportion = false;
      let url =
        this.httpsBasic.url +
        this.httpsBasic.people +
        "Guard/setJustProjectProportion";
      axios
        .post(url, {
          token: window.localStorage.getItem("xnwfPcToken"),
          project_id: this.proprotionVal.id,
          proportion: this.proportion
        })
        .then(res => {
          if (res.data.code == 200) {
            this.$message.success("设置成功");
            this.reload();
          } else {
            this.$message.warning(res.data.message);
          }
        })
        .catch(err => {
          this.$message.error("服务器出错了...");
        });
    },
    setProProportion(val) {
      this.proprotionVal = val;
      this.proportion = this.proprotionVal.proportion;
      this.showIsProportion = true;
    },
    onDownload() {
      window.location.href =
        this.httpsBasic.url +
        this.httpsBasic.retail +
        "Guard/projectOrderCountDownload?token=" +
        window.localStorage.getItem("xnwfPcToken") +
        "&project_id=" +
        this.project_id +
        "&query_field=" +
        this.query_field +
        "&start_date=" +
        this.start_date +
        "&end_date=" +
        this.end_date;
    },
    onReset() {
      this.query_field = "";
      this.start_date = "";
      this.end_date = "";
      this.project_id = "";
      this.dateDefault = undefined;
      this.page = 1;
      this.getData();
    },
    filterOption(input, option) {
      return (
        option.componentOptions.children[0].text
          .toLowerCase()
          .indexOf(input.toLowerCase()) >= 0
      );
    },
    getPro() {
      let url =
        this.httpsBasic.url +
        this.httpsBasic.trade +
        "Project/queryManagerProject";
      axios
        .post(url, {
          token: window.localStorage.getItem("xnwfPcToken"),
          trade_id: 2
        })
        .then(res => {
          if (res.data.code == 200) {
            this.proList = res.data.data;
            //  console.log(this.proList);
          }
        });
    },
    selectedDate(data, dataString) {
      // console.log(dataString)
      this.start_date = dataString;
      this.end_date = dataString;
    },
    onChange(pageNumber) {
      this.page = pageNumber;
      this.getData();
    },
    reload() {
      this.$nextTick(function() {
        this.getData();
      });
    },
    onSearch(value) {
      this.page = 1;
      // this.query_field = value;
      this.getData();
      // console.log(value);
    },
    getData() {
      // console.log(this.$store.state.token);
      this.loading = true;
      this.data = [];
      let url =
        this.httpsBasic.url +
        this.httpsBasic.retail +
        "Guard/projectOrderCount";
      axios
        .post(url, {
          current_page: this.page,
          per_page: 10,
          query_field: this.query_field,
          start_date: this.start_date,
          end_date: this.end_date,
          project_id: this.project_id,
          token: window.localStorage.getItem("xnwfPcToken")
        })
        .then(res => {
          if (res.data.code == 200) {
            this.data = res.data.data.data;
            console.log(this.data);
            this.loading = false;
            const pagination = { ...this.pagination };
            pagination.total = res.data.data.total;
            this.pagination = pagination;
          } else {
            this.$message.warning(res.data.message);
            this.loading = false;
          }
        })
        .catch(err => {
          this.$message.error("服务器出错啦...");
          this.loading = false;
        });
    },
    handleChange(value, key, column) {
      const newData = [...this.data];
      const target = newData.filter(item => key === item.id)[0];
      if (target) {
        target[column] = value;
        this.data = newData;
      }
    },
    edit(detail) {
      this.hideInUserEdit = true;
      this.editDetail = detail;
    }
  }
};
</script>
<style lang="less" scoped>
@import url(../../style/listBasic.less);
.listContainer {
  .searchBox {
    display: block;
    > span {
      display: inline-block;
      margin-right: 20px;
      a {
        display: inline-block;
        input {
          width: 200px;
        }
      }
    }
  }
}
</style>
<style lang="less">
.ant-table {
  min-height: 58vh;
}
</style>
